import { makeStyles } from "@material-ui/core";


const bannerFontColor = "#2196F3";
const bannerBackgroundColor = "#E4F2FE";

export default makeStyles((theme) => ({
    camera: {
        display: "flex",
        alignItems: "center",
        color: theme.palette.grey[700],
        "&:first-child": {
            marginRight: 4,
        },
    },
    close: {
        backgroundColor: "rgba(0,0,0,0.5)",
        "&:hover": {
            backgroundColor: "rgba(0,0,0,0.7)",
        },
        color: theme.palette.common.white,
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 2, //For a dewarped video, the error screen from PanoramaStream component (video js lib) overlaps the close button and renders it useless.
    },
    dialog: {
        minWidth: 800,
        borderRadius: 8,
    },
    download: {
        "&:hover": {
            backgroundColor: "rgba(0,0,0,0.1)",
        },
        color: theme.palette.grey[700],
        height: 48,
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        padding: 16,
    },
    primaryText: {
        display: "flex",
        color: theme.palette.grey[900],
        fontSize: 20,
        fontWeight: 600,
        "& div": {
            marginRight: 12,
        },
    },
    secondaryText: {
        display: "flex",
        flexWrap: "wrap",
        color: theme.palette.grey[700],
        fontSize: 16,
        fontWeight: 400,
        "& div": {
            marginRight: 12,
        },
    },
    video: {
        aspectRatio: "16 / 9",
        "& video": {
            objectFit: "contain",
            backgroundColor: "black",
            width: "100%",
        },
    },
    panoVideoBanner: {
        display: "flex",
        backgroundColor: bannerBackgroundColor,
        color: bannerFontColor,
        padding: "8px 16px",
    },
    panoVideoBannerTitle: {
        marginLeft: "0.5em",
    },
}));
